// @ts-nocheck
import { getIsConfigured } from "@store/Framework/Services/Pages/UserSetup/MailChimpEmailService";
import { ApiHandlerNoParameter, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandlerNoParameter<boolean>;

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getIsConfigured();
};

export const DispatchCompleteSetIsConfigured: HandlerType = props => {
    const { dispatch, apiResult } = props;
    dispatch({
        type: "Store/Pages/UserSetup/SetIsConfigured",
        isConfigured: apiResult,
    });
};

export const chain = [RequestDataFromApi, DispatchCompleteSetIsConfigured];

const getMailChimpIsConfigured = createHandlerChainRunner(chain, "GetMailChimpIsConfigured");
export default getMailChimpIsConfigured;
